import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { Wordmark } from "./Logo";
import { scrollToId } from "./Reveal";
import { profile } from "@/data/content";

const links = [
  ["reel", "Reel"],
  ["animations", "Animations"],
  ["criteria", "Criteria"],
  ["process", "Process"],
  ["about", "About"],
];

export const Nav = () => {
  const [open, setOpen] = useState(false);
  const go = (id) => { setOpen(false); scrollToId(id); };

  return (
    <motion.header
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
      className="fixed inset-x-0 top-0 z-50 border-b border-[#E0E8F2]/80 bg-white/85 backdrop-blur-xl"
      data-testid="site-header"
    >
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-5 sm:px-8">
        <button onClick={() => go("top")} data-testid="nav-logo" aria-label="Back to top">
          <Wordmark name={profile.name} />
        </button>
        <nav className="hidden items-center gap-1 lg:flex">
          {links.map(([id, label]) => (
            <button key={id} onClick={() => go(id)} data-testid={`nav-${id}-link`}
              className="nav-link rounded-full px-4 py-2 text-sm text-[#05325F] transition-colors hover:bg-[#F0F5FA]">
              {label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <a href={`mailto:${profile.email}`} data-testid="nav-contact-button"
            className="group hidden items-center gap-2 rounded-full bg-[#05325F] px-5 py-2.5 text-sm font-bold text-white transition-colors hover:bg-[#005EB8] sm:flex">
            Get in touch
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </a>
          <button onClick={() => setOpen((v) => !v)} className="rounded-full p-2 text-[#05325F] lg:hidden"
            data-testid="nav-mobile-toggle" aria-label="Toggle menu">
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav initial={{ height: 0 }} animate={{ height: "auto" }} exit={{ height: 0 }}
            className="overflow-hidden border-t border-[#E0E8F2] bg-white lg:hidden" data-testid="nav-mobile-menu">
            <div className="flex flex-col px-5 py-4">
              {links.map(([id, label]) => (
                <button key={id} onClick={() => go(id)} data-testid={`nav-mobile-${id}-link`}
                  className="border-b border-[#E0E8F2] py-4 text-left text-2xl font-bold text-[#05325F]">
                  {label}
                </button>
              ))}
              <a href={`mailto:${profile.email}`} data-testid="nav-mobile-contact-button"
                className="mt-5 rounded-full bg-[#05325F] py-4 text-center font-bold text-white">Get in touch</a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
